import { FC, useEffect } from 'react';
import {
  WbDockableGroup,
  WbDockablePanel,
  WbDockableResizeHandle,
  WbTabsProvider,
} from '@agilelab/plugin-wb-platform';
import { TeamRolesCard } from './TeamRolesCard';
import { TeamRoleAssignmentsCard } from './TeamRoleAssignmentsCard';
import { teamRolesNavigatedTopic } from '@agilelab/plugin-wb-events-common';
import { useTeamRolesPanelContext } from '../../context';
import { usePublishEvent } from '@agilelab/plugin-wb-events';
import { stringifyEntityRef } from '@backstage/catalog-model';

export const TeamRolesPanel: FC = () => {
  const { project, projectUrn } = useTeamRolesPanelContext();
  const { publish } = usePublishEvent({
    generatorSystem: 'builder',
    keyBuilderCatalog: stringifyEntityRef(project),
  });

  useEffect(() => {
    publish(teamRolesNavigatedTopic, {
      entityUrn: projectUrn,
    });
  }, [projectUrn, publish]);

  return (
    <WbTabsProvider>
      <WbDockableGroup direction="horizontal">
        <WbDockablePanel defaultSize={15} maxSize={25}>
          <TeamRolesCard />
        </WbDockablePanel>

        <WbDockableResizeHandle
          showIconOnHover
          divider
          size={4}
          direction="horizontal"
        />

        <WbDockablePanel maxSize={85}>
          <TeamRoleAssignmentsCard />
        </WbDockablePanel>
      </WbDockableGroup>
    </WbTabsProvider>
  );
};
